<template>
  <div class="wrap" v-if="isVisible">
    <div v-if="isFetching" class="spinner-wrapper">
      <div class="btn-spinner"></div>
    </div>
    <a v-else class="more" @click="handleClick">
      <span>{{ isCloseState ? 'Close' : 'See More' }}</span>
      <img
          src="@/assets/images/icon/ico_toggle_y.svg"
          alt=""
          :style="{ transform: isCloseState ? 'rotate(180deg)' : 'rotate(0deg)' }"
      />
    </a>
  </div>
</template>

<script setup>
import {ref, computed, defineProps} from 'vue';

const isFetching = ref(false);
const props = defineProps({
  totalPages: {
    type: Number,
    required: false,
    default: 0,
  },
  currentPage: {
    type: Number,
    required: false,
    default: 0,
  },
  fetchItems: {
    type: Function,
    required: false,
    default: null,
  },
  itemRef: {
    type: HTMLElement,
    required: false,
  },
  // onMore 를 넘기면 "더보기 위임" 모드. 노출 여부는 hasMore 만 보고,
  // 다 보여준 뒤에는 Close 대신 버튼 영역 자체가 사라진다. (GH#188 작가 상세)
  // 넘기지 않으면 기존 totalPages/currentPage/fetchItems 동작 그대로.
  hasMore: {
    type: Boolean,
    default: false,
  },
  onMore: {
    type: Function,
    default: null,
  },
});

const isDelegated = computed(() => typeof props.onMore === 'function');
const isVisible = computed(() => (isDelegated.value ? props.hasMore : props.totalPages > 1));
const isCloseState = computed(() => !isDelegated.value && props.currentPage + 1 >= props.totalPages);

const handleClick = async () => {
  if (isDelegated.value) {
    isFetching.value = true;
    try {
      await props.onMore();
    } finally {
      isFetching.value = false;
    }
    return;
  }

  if (props.currentPage + 1 < props.totalPages) {
    isFetching.value = true;
    await props.fetchItems(props.currentPage + 1, true);
    isFetching.value = false;
  } else {
    await props.fetchItems(0);
    props.itemRef.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center"
    });
  }
};
</script>

<style scoped>
.spinner-wrapper {
  height: 85px;
}

@media (max-width: 768px) {
  .wrap {
    margin-top: 30px;
  }

  .wrap a.more {
    row-gap: 6px;
  }

  .wrap a.more span {
    font-size: 14px;
  }

  .wrap a.more img {
    width: 12px;
    height: 5px;
  }

  .spinner-wrapper {
    height: 31px;
  }
}

</style>
